/* =========================================================
   ABS DEVELOPERS — PROJECTS SHOWCASE
   File: assets/abs-project-showcase.js
   Lead integration — reliable fetch submission version
   ========================================================= */

(() => {
  'use strict';

  const SELECTORS = {
    section: '.abs-projects',
    card: '[data-abs-project-card]',
    openButton: '[data-abs-enquiry-open]',
    modal: '[data-abs-enquiry-modal]',
    modalPanel: '[data-abs-enquiry-panel]',
    closeButton: '[data-abs-enquiry-close]',
    projectInput: '[data-abs-project-input]',
    projectDisplay: '[data-abs-project-display]',
    pageUrlInput: '[data-abs-page-url]',
    requestIdInput: '[data-abs-request-id]',
    countryPicker: '[data-abs-country-picker]',
    countryTrigger: '[data-abs-country-trigger]',
    countryMenu: '[data-abs-country-menu]',
    countrySearch: '[data-abs-country-search]',
    countryOptions: '[data-abs-country-options]',
    countryEmpty: '[data-abs-country-empty]',
    countryFlag: '[data-abs-country-flag]',
    countryName: '[data-abs-country-name]',
    countryCodeLabel: '[data-abs-country-code-label]',
    phoneCountry: '[data-abs-phone-country]',
    phoneLocal: '[data-abs-phone-local]',
    phoneFull: '[data-abs-phone-full]',
    whatsappCountry: '[data-abs-whatsapp-country]',
    whatsappLocal: '[data-abs-whatsapp-local]',
    whatsappFull: '[data-abs-whatsapp-full]',
    whatsappSame: '[data-abs-whatsapp-same]',
    whatsappEntry: '[data-abs-whatsapp-entry]',
    form: '[data-abs-enquiry-form]',
    submitButton: '[data-abs-submit]',
    successState: '[data-abs-form-success]',
    errorState: '[data-abs-form-error]',
    descriptionOpen: '[data-abs-description-open]',
    descriptionModal: '[data-abs-description-modal]',
    descriptionPanel: '[data-abs-description-panel]',
    descriptionClose: '[data-abs-description-close]',
    descriptionTitle: '[data-abs-description-title]',
    descriptionLocation: '[data-abs-description-location]',
    descriptionBody: '[data-abs-description-body]'
  };

  const CLASSNAMES = {
    jsReady: 'abs-js-ready',
    revealReady: 'abs-reveal-ready',
    revealed: 'is-revealed',
    modalOpen: 'is-open',
    bodyLocked: 'abs-modal-open',
    submitting: 'is-submitting',
    success: 'is-success',
    error: 'is-error'
  };

  const state = {
    activeModal: null,
    activeDescriptionModal: null,
    lastFocusedElement: null,
    lastDescriptionFocusedElement: null
  };

  const SUBMISSION_TIMEOUT_MS = 15000;

  const COUNTRIES = [{"name":"Afghanistan","code":"+93"},{"name":"Albania","code":"+355"},{"name":"Algeria","code":"+213"},{"name":"American Samoa","code":"+1684"},{"name":"Andorra","code":"+376"},{"name":"Angola","code":"+244"},{"name":"Anguilla","code":"+1264"},{"name":"Antigua & Barbuda","code":"+1268"},{"name":"Argentina","code":"+54"},{"name":"Armenia","code":"+374"},{"name":"Aruba","code":"+297"},{"name":"Australia","code":"+61"},{"name":"Austria","code":"+43"},{"name":"Azerbaijan","code":"+994"},{"name":"Bahamas","code":"+1242"},{"name":"Bahrain","code":"+973"},{"name":"Bangladesh","code":"+880"},{"name":"Barbados","code":"+1246"},{"name":"Belarus","code":"+375"},{"name":"Belgium","code":"+32"},{"name":"Belize","code":"+501"},{"name":"Benin","code":"+229"},{"name":"Bermuda","code":"+1441"},{"name":"Bhutan","code":"+975"},{"name":"Bolivia","code":"+591"},{"name":"Bosnia & Herzegovina","code":"+387"},{"name":"Botswana","code":"+267"},{"name":"Brazil","code":"+55"},{"name":"Brunei","code":"+673"},{"name":"Bulgaria","code":"+359"},{"name":"Burkina Faso","code":"+226"},{"name":"Burundi","code":"+257"},{"name":"Cambodia","code":"+855"},{"name":"Cameroon","code":"+237"},{"name":"Canada","code":"+1"},{"name":"Cape Verde","code":"+238"},{"name":"Cayman Islands","code":"+1345"},{"name":"Central African Republic","code":"+236"},{"name":"Chad","code":"+235"},{"name":"Chile","code":"+56"},{"name":"China","code":"+86"},{"name":"Colombia","code":"+57"},{"name":"Comoros","code":"+269"},{"name":"Congo","code":"+242"},{"name":"Congo, DR","code":"+243"},{"name":"Cook Islands","code":"+682"},{"name":"Costa Rica","code":"+506"},{"name":"Croatia","code":"+385"},{"name":"Cuba","code":"+53"},{"name":"Cyprus","code":"+357"},{"name":"Czech Republic","code":"+420"},{"name":"Denmark","code":"+45"},{"name":"Djibouti","code":"+253"},{"name":"Dominica","code":"+1767"},{"name":"Dominican Republic","code":"+1809"},{"name":"Ecuador","code":"+593"},{"name":"Egypt","code":"+20"},{"name":"El Salvador","code":"+503"},{"name":"Equatorial Guinea","code":"+240"},{"name":"Eritrea","code":"+291"},{"name":"Estonia","code":"+372"},{"name":"Eswatini","code":"+268"},{"name":"Ethiopia","code":"+251"},{"name":"Falkland Islands","code":"+500"},{"name":"Faroe Islands","code":"+298"},{"name":"Fiji","code":"+679"},{"name":"Finland","code":"+358"},{"name":"France","code":"+33"},{"name":"French Guiana","code":"+594"},{"name":"French Polynesia","code":"+689"},{"name":"Gabon","code":"+241"},{"name":"Gambia","code":"+220"},{"name":"Georgia","code":"+995"},{"name":"Germany","code":"+49"},{"name":"Ghana","code":"+233"},{"name":"Gibraltar","code":"+350"},{"name":"Greece","code":"+30"},{"name":"Greenland","code":"+299"},{"name":"Grenada","code":"+1473"},{"name":"Guadeloupe","code":"+590"},{"name":"Guam","code":"+1671"},{"name":"Guatemala","code":"+502"},{"name":"Guernsey","code":"+44"},{"name":"Guinea","code":"+224"},{"name":"Guinea-Bissau","code":"+245"},{"name":"Guyana","code":"+592"},{"name":"Haiti","code":"+509"},{"name":"Honduras","code":"+504"},{"name":"Hong Kong","code":"+852"},{"name":"Hungary","code":"+36"},{"name":"Iceland","code":"+354"},{"name":"India","code":"+91"},{"name":"Indonesia","code":"+62"},{"name":"Iran","code":"+98"},{"name":"Iraq","code":"+964"},{"name":"Ireland","code":"+353"},{"name":"Isle of Man","code":"+44"},{"name":"Israel","code":"+972"},{"name":"Italy","code":"+39"},{"name":"Ivory Coast","code":"+225"},{"name":"Jamaica","code":"+1876"},{"name":"Japan","code":"+81"},{"name":"Jersey","code":"+44"},{"name":"Jordan","code":"+962"},{"name":"Kazakhstan","code":"+7"},{"name":"Kenya","code":"+254"},{"name":"Kiribati","code":"+686"},{"name":"Kuwait","code":"+965"},{"name":"Kyrgyzstan","code":"+996"},{"name":"Laos","code":"+856"},{"name":"Latvia","code":"+371"},{"name":"Lebanon","code":"+961"},{"name":"Lesotho","code":"+266"},{"name":"Liberia","code":"+231"},{"name":"Libya","code":"+218"},{"name":"Liechtenstein","code":"+423"},{"name":"Lithuania","code":"+370"},{"name":"Luxembourg","code":"+352"},{"name":"Macau","code":"+853"},{"name":"Madagascar","code":"+261"},{"name":"Malawi","code":"+265"},{"name":"Malaysia","code":"+60"},{"name":"Maldives","code":"+960"},{"name":"Mali","code":"+223"},{"name":"Malta","code":"+356"},{"name":"Marshall Islands","code":"+692"},{"name":"Martinique","code":"+596"},{"name":"Mauritania","code":"+222"},{"name":"Mauritius","code":"+230"},{"name":"Mayotte","code":"+262"},{"name":"Mexico","code":"+52"},{"name":"Micronesia","code":"+691"},{"name":"Moldova","code":"+373"},{"name":"Monaco","code":"+377"},{"name":"Mongolia","code":"+976"},{"name":"Montenegro","code":"+382"},{"name":"Montserrat","code":"+1664"},{"name":"Morocco","code":"+212"},{"name":"Mozambique","code":"+258"},{"name":"Myanmar","code":"+95"},{"name":"Namibia","code":"+264"},{"name":"Nauru","code":"+674"},{"name":"Nepal","code":"+977"},{"name":"Netherlands","code":"+31"},{"name":"New Caledonia","code":"+687"},{"name":"New Zealand","code":"+64"},{"name":"Nicaragua","code":"+505"},{"name":"Niger","code":"+227"},{"name":"Nigeria","code":"+234"},{"name":"Niue","code":"+683"},{"name":"North Korea","code":"+850"},{"name":"North Macedonia","code":"+389"},{"name":"Northern Mariana Islands","code":"+1670"},{"name":"Norway","code":"+47"},{"name":"Oman","code":"+968"},{"name":"Pakistan","code":"+92"},{"name":"Palau","code":"+680"},{"name":"Palestine","code":"+970"},{"name":"Panama","code":"+507"},{"name":"Papua New Guinea","code":"+675"},{"name":"Paraguay","code":"+595"},{"name":"Peru","code":"+51"},{"name":"Philippines","code":"+63"},{"name":"Poland","code":"+48"},{"name":"Portugal","code":"+351"},{"name":"Puerto Rico","code":"+1787"},{"name":"Qatar","code":"+974"},{"name":"Réunion","code":"+262"},{"name":"Romania","code":"+40"},{"name":"Russia","code":"+7"},{"name":"Rwanda","code":"+250"},{"name":"Saint Barthélemy","code":"+590"},{"name":"Saint Helena","code":"+290"},{"name":"Saint Kitts & Nevis","code":"+1869"},{"name":"Saint Lucia","code":"+1758"},{"name":"Saint Martin","code":"+590"},{"name":"Saint Pierre & Miquelon","code":"+508"},{"name":"Saint Vincent & Grenadines","code":"+1784"},{"name":"Samoa","code":"+685"},{"name":"San Marino","code":"+378"},{"name":"São Tomé & Príncipe","code":"+239"},{"name":"Saudi Arabia","code":"+966"},{"name":"Senegal","code":"+221"},{"name":"Serbia","code":"+381"},{"name":"Seychelles","code":"+248"},{"name":"Sierra Leone","code":"+232"},{"name":"Singapore","code":"+65"},{"name":"Slovakia","code":"+421"},{"name":"Slovenia","code":"+386"},{"name":"Solomon Islands","code":"+677"},{"name":"Somalia","code":"+252"},{"name":"South Africa","code":"+27"},{"name":"South Korea","code":"+82"},{"name":"South Sudan","code":"+211"},{"name":"Spain","code":"+34"},{"name":"Sri Lanka","code":"+94"},{"name":"Sudan","code":"+249"},{"name":"Suriname","code":"+597"},{"name":"Sweden","code":"+46"},{"name":"Switzerland","code":"+41"},{"name":"Syria","code":"+963"},{"name":"Taiwan","code":"+886"},{"name":"Tajikistan","code":"+992"},{"name":"Tanzania","code":"+255"},{"name":"Thailand","code":"+66"},{"name":"Timor-Leste","code":"+670"},{"name":"Togo","code":"+228"},{"name":"Tokelau","code":"+690"},{"name":"Tonga","code":"+676"},{"name":"Trinidad & Tobago","code":"+1868"},{"name":"Tunisia","code":"+216"},{"name":"Türkiye","code":"+90"},{"name":"Turkmenistan","code":"+993"},{"name":"Turks & Caicos","code":"+1649"},{"name":"Tuvalu","code":"+688"},{"name":"Uganda","code":"+256"},{"name":"Ukraine","code":"+380"},{"name":"United Arab Emirates","code":"+971"},{"name":"United Kingdom","code":"+44"},{"name":"United States","code":"+1"},{"name":"Uruguay","code":"+598"},{"name":"Uzbekistan","code":"+998"},{"name":"Vanuatu","code":"+678"},{"name":"Vatican City","code":"+379"},{"name":"Venezuela","code":"+58"},{"name":"Vietnam","code":"+84"},{"name":"Virgin Islands, British","code":"+1284"},{"name":"Virgin Islands, U.S.","code":"+1340"},{"name":"Wallis & Futuna","code":"+681"},{"name":"Yemen","code":"+967"},{"name":"Zambia","code":"+260"},{"name":"Zimbabwe","code":"+263"}];

  function countryFlag(name) {
    const flagMap = {
      Afghanistan: '🇦🇫',
      Albania: '🇦🇱',
      Algeria: '🇩🇿',
      Andorra: '🇦🇩',
      Angola: '🇦🇴',
      Argentina: '🇦🇷',
      Armenia: '🇦🇲',
      Australia: '🇦🇺',
      Austria: '🇦🇹',
      Azerbaijan: '🇦🇿',
      Bahrain: '🇧🇭',
      Bangladesh: '🇧🇩',
      Belarus: '🇧🇾',
      Belgium: '🇧🇪',
      Brazil: '🇧🇷',
      Brunei: '🇧🇳',
      Bulgaria: '🇧🇬',
      Cambodia: '🇰🇭',
      Cameroon: '🇨🇲',
      Canada: '🇨🇦',
      Chile: '🇨🇱',
      China: '🇨🇳',
      Colombia: '🇨🇴',
      Croatia: '🇭🇷',
      Cyprus: '🇨🇾',
      Denmark: '🇩🇰',
      Egypt: '🇪🇬',
      Estonia: '🇪🇪',
      Ethiopia: '🇪🇹',
      Finland: '🇫🇮',
      France: '🇫🇷',
      Georgia: '🇬🇪',
      Germany: '🇩🇪',
      Ghana: '🇬🇭',
      Greece: '🇬🇷',
      'Hong Kong': '🇭🇰',
      Hungary: '🇭🇺',
      Iceland: '🇮🇸',
      India: '🇮🇳',
      Indonesia: '🇮🇩',
      Iran: '🇮🇷',
      Iraq: '🇮🇶',
      Ireland: '🇮🇪',
      Italy: '🇮🇹',
      Japan: '🇯🇵',
      Jordan: '🇯🇴',
      Kazakhstan: '🇰🇿',
      Kenya: '🇰🇪',
      Kuwait: '🇰🇼',
      Lebanon: '🇱🇧',
      Libya: '🇱🇾',
      Malaysia: '🇲🇾',
      Maldives: '🇲🇻',
      Mexico: '🇲🇽',
      Morocco: '🇲🇦',
      Nepal: '🇳🇵',
      Netherlands: '🇳🇱',
      'New Zealand': '🇳🇿',
      Nigeria: '🇳🇬',
      Norway: '🇳🇴',
      Oman: '🇴🇲',
      Pakistan: '🇵🇰',
      Palestine: '🇵🇸',
      Philippines: '🇵🇭',
      Poland: '🇵🇱',
      Portugal: '🇵🇹',
      Qatar: '🇶🇦',
      Romania: '🇷🇴',
      Russia: '🇷🇺',
      'Saudi Arabia': '🇸🇦',
      Singapore: '🇸🇬',
      'South Africa': '🇿🇦',
      'South Korea': '🇰🇷',
      Spain: '🇪🇸',
      'Sri Lanka': '🇱🇰',
      Sweden: '🇸🇪',
      Switzerland: '🇨🇭',
      Taiwan: '🇹🇼',
      Thailand: '🇹🇭',
      Türkiye: '🇹🇷',
      Ukraine: '🇺🇦',
      'United Arab Emirates': '🇦🇪',
      'United Kingdom': '🇬🇧',
      'United States': '🇺🇸',
      Vietnam: '🇻🇳'
    };

    return flagMap[name] || '🌐';
  }

  function getFocusableElements(container) {
    if (!container) return [];

    return Array.from(
      container.querySelectorAll(
        [
          'a[href]',
          'button:not([disabled])',
          'textarea:not([disabled])',
          'input:not([disabled]):not([type="hidden"])',
          'select:not([disabled])',
          '[tabindex]:not([tabindex="-1"])'
        ].join(',')
      )
    ).filter((element) => {
      return !element.hasAttribute('hidden') && element.offsetParent !== null;
    });
  }

  function createRequestId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID().replace(/-/g, '');
    }

    return [
      Date.now().toString(36),
      Math.random().toString(36).slice(2, 10),
      Math.random().toString(36).slice(2, 10)
    ].join('_');
  }

  function setProjectName(modal, projectName) {
    if (!modal) return;

    const input = modal.querySelector(SELECTORS.projectInput);
    const displays = modal.querySelectorAll(SELECTORS.projectDisplay);

    if (input) {
      input.value = projectName || '';
    }

    displays.forEach((display) => {
      display.textContent = projectName || '';
    });
  }

  function setPageUrl(form) {
    if (!form) return;

    const input = form.querySelector(SELECTORS.pageUrlInput);

    if (input) {
      input.value = window.location.href;
    }
  }

  function normalizeDigits(value) {
    return String(value || '').replace(/\D/g, '');
  }

  function buildFullNumber(countryCode, localNumber) {
    const code = String(countryCode || '').trim();
    const local = String(localNumber || '').trim();

    if (!code || !local) {
      return '';
    }

    return `${code} ${local}`.replace(/\s+/g, ' ').trim();
  }

  function getPickerHiddenInput(picker) {
    if (!picker) return null;

    const target = picker.dataset.absCountryTarget;

    return target === 'whatsapp'
      ? picker.querySelector(SELECTORS.whatsappCountry)
      : picker.querySelector(SELECTORS.phoneCountry);
  }

  function setPickerCountry(picker, country, form, syncAfter = true) {
    if (!picker || !country) return;

    const flag = picker.querySelector(SELECTORS.countryFlag);
    const name = picker.querySelector(SELECTORS.countryName);
    const codeLabel = picker.querySelector(SELECTORS.countryCodeLabel);
    const hiddenInput = getPickerHiddenInput(picker);

    picker.dataset.absSelectedCountry = country.name;
    picker.dataset.absSelectedCode = country.code;

    if (flag) flag.textContent = countryFlag(country.name);
    if (name) name.textContent = country.name;
    if (codeLabel) codeLabel.textContent = country.code;
    if (hiddenInput) hiddenInput.value = country.code;

    if (syncAfter && form) {
      syncAllPhoneNumbers(form);
    }
  }

  function filterCountries(query) {
    const cleanQuery = String(query || '').trim().toLowerCase();
    const digits = normalizeDigits(cleanQuery);

    if (!cleanQuery) {
      return COUNTRIES;
    }

    return COUNTRIES.filter((country) => {
      const name = country.name.toLowerCase();
      const codeDigits = normalizeDigits(country.code);

      return (
        name.includes(cleanQuery) ||
        country.code.includes(cleanQuery) ||
        (digits && codeDigits.includes(digits))
      );
    });
  }

  function renderCountryOptions(picker, form, query = '') {
    if (!picker) return;

    const optionsRoot = picker.querySelector(SELECTORS.countryOptions);
    const emptyState = picker.querySelector(SELECTORS.countryEmpty);

    if (!optionsRoot) return;

    optionsRoot.innerHTML = '';

    const matches = filterCountries(query).slice(0, 80);

    if (emptyState) {
      emptyState.hidden = matches.length !== 0;
    }

    matches.forEach((country) => {
      const option = document.createElement('button');

      option.type = 'button';
      option.className = 'abs-country-picker__option';
      option.setAttribute('role', 'option');
      option.dataset.absCountryOption = 'true';
      option.dataset.countryName = country.name;
      option.dataset.countryCode = country.code;

      const selected =
        picker.dataset.absSelectedCountry === country.name &&
        picker.dataset.absSelectedCode === country.code;

      option.setAttribute('aria-selected', selected ? 'true' : 'false');

      option.innerHTML = `
        <span class="abs-country-picker__option-main">
          <span class="abs-country-picker__option-flag" aria-hidden="true">${countryFlag(country.name)}</span>
          <span class="abs-country-picker__option-name"></span>
        </span>
        <span class="abs-country-picker__option-code"></span>
      `;

      option.querySelector('.abs-country-picker__option-name').textContent =
        country.name;

      option.querySelector('.abs-country-picker__option-code').textContent =
        country.code;

      option.addEventListener('click', () => {
        setPickerCountry(picker, country, form);
        closeCountryPicker(picker);
      });

      optionsRoot.appendChild(option);
    });
  }

  function openCountryPicker(picker, form) {
    if (!picker) return;

    document.querySelectorAll(SELECTORS.countryPicker).forEach((otherPicker) => {
      if (otherPicker !== picker) {
        closeCountryPicker(otherPicker);
      }
    });

    const trigger = picker.querySelector(SELECTORS.countryTrigger);
    const menu = picker.querySelector(SELECTORS.countryMenu);
    const search = picker.querySelector(SELECTORS.countrySearch);

    if (!trigger || !menu) return;

    menu.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    picker.classList.add('is-open');

    renderCountryOptions(picker, form, '');

    if (search) {
      search.value = '';

      window.requestAnimationFrame(() => {
        search.focus({ preventScroll: true });
      });
    }
  }

  function closeCountryPicker(picker) {
    if (!picker) return;

    const trigger = picker.querySelector(SELECTORS.countryTrigger);
    const menu = picker.querySelector(SELECTORS.countryMenu);

    if (menu) menu.hidden = true;
    if (trigger) trigger.setAttribute('aria-expanded', 'false');

    picker.classList.remove('is-open');
  }

  function syncAllPhoneNumbers(form) {
    if (!form) return;

    const phoneCountry = form.querySelector(SELECTORS.phoneCountry);
    const phoneLocal = form.querySelector(SELECTORS.phoneLocal);
    const phoneFull = form.querySelector(SELECTORS.phoneFull);

    const whatsappCountry = form.querySelector(SELECTORS.whatsappCountry);
    const whatsappLocal = form.querySelector(SELECTORS.whatsappLocal);
    const whatsappFull = form.querySelector(SELECTORS.whatsappFull);
    const whatsappSame = form.querySelector(SELECTORS.whatsappSame);

    const phoneFullNumber = buildFullNumber(
      phoneCountry?.value,
      phoneLocal?.value
    );

    if (phoneFull) {
      phoneFull.value = phoneFullNumber;
    }

    if (whatsappSame?.checked) {
      if (whatsappCountry && phoneCountry) {
        whatsappCountry.value = phoneCountry.value;
      }

      if (whatsappLocal && phoneLocal) {
        whatsappLocal.value = phoneLocal.value;
      }

      if (whatsappFull) {
        whatsappFull.value = phoneFullNumber;
      }

      const phonePicker = form.querySelector(
        `${SELECTORS.countryPicker}[data-abs-country-target="phone"]`
      );

      const whatsappPicker = form.querySelector(
        `${SELECTORS.countryPicker}[data-abs-country-target="whatsapp"]`
      );

      if (phonePicker && whatsappPicker) {
        const country =
          COUNTRIES.find((item) => {
            return (
              item.name === phonePicker.dataset.absSelectedCountry &&
              item.code === phonePicker.dataset.absSelectedCode
            );
          }) ||
          COUNTRIES.find((item) => item.code === phoneCountry?.value);

        if (country) {
          setPickerCountry(whatsappPicker, country, form, false);
        }
      }

      return;
    }

    const whatsappFullNumber = buildFullNumber(
      whatsappCountry?.value,
      whatsappLocal?.value
    );

    if (whatsappFull) {
      whatsappFull.value = whatsappFullNumber;
    }
  }

  function setWhatsAppSameState(form) {
    if (!form) return;

    const sameCheckbox = form.querySelector(SELECTORS.whatsappSame);
    const whatsappEntry = form.querySelector(SELECTORS.whatsappEntry);
    const whatsappLocal = form.querySelector(SELECTORS.whatsappLocal);
    const whatsappPicker = form.querySelector(
      `${SELECTORS.countryPicker}[data-abs-country-target="whatsapp"]`
    );
    const whatsappTrigger = whatsappPicker?.querySelector(
      SELECTORS.countryTrigger
    );

    const isSame = Boolean(sameCheckbox?.checked);

    if (whatsappEntry) {
      whatsappEntry.classList.toggle('is-linked', isSame);
    }

    if (whatsappLocal) {
      whatsappLocal.disabled = isSame;
    }

    if (whatsappTrigger) {
      whatsappTrigger.disabled = isSame;
    }

    if (isSame && whatsappPicker) {
      closeCountryPicker(whatsappPicker);
    }

    syncAllPhoneNumbers(form);
  }

  function initCountryPicker(picker, form) {
    if (!picker || picker.dataset.absCountryPickerInitialized === 'true') {
      return;
    }

    picker.dataset.absCountryPickerInitialized = 'true';

    const trigger = picker.querySelector(SELECTORS.countryTrigger);
    const search = picker.querySelector(SELECTORS.countrySearch);

    const defaultCountry =
      COUNTRIES.find((country) => country.name === 'Pakistan') ||
      COUNTRIES.find((country) => country.code === '+92') ||
      COUNTRIES[0];

    setPickerCountry(picker, defaultCountry, form, false);
    renderCountryOptions(picker, form, '');

    if (trigger) {
      trigger.addEventListener('click', () => {
        if (trigger.disabled) return;

        const isOpen = picker.classList.contains('is-open');

        if (isOpen) {
          closeCountryPicker(picker);
        } else {
          openCountryPicker(picker, form);
        }
      });
    }

    if (search) {
      search.addEventListener('input', () => {
        renderCountryOptions(picker, form, search.value);
      });

      search.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeCountryPicker(picker);

          if (trigger) {
            trigger.focus({ preventScroll: true });
          }

          return;
        }

        if (event.key === 'Enter') {
          const firstOption = picker.querySelector(
            '[data-abs-country-option="true"]'
          );

          if (firstOption) {
            event.preventDefault();
            firstOption.click();
          }
        }
      });
    }
  }

  function initPhoneFields(form) {
    if (!form || form.dataset.absPhoneFieldsInitialized === 'true') {
      return;
    }

    form.dataset.absPhoneFieldsInitialized = 'true';

    form.querySelectorAll(SELECTORS.countryPicker).forEach((picker) => {
      initCountryPicker(picker, form);
    });

    const phoneLocal = form.querySelector(SELECTORS.phoneLocal);
    const whatsappLocal = form.querySelector(SELECTORS.whatsappLocal);
    const whatsappSame = form.querySelector(SELECTORS.whatsappSame);

    if (phoneLocal) {
      phoneLocal.addEventListener('input', () => {
        syncAllPhoneNumbers(form);
      });
    }

    if (whatsappLocal) {
      whatsappLocal.addEventListener('input', () => {
        syncAllPhoneNumbers(form);
      });
    }

    if (whatsappSame) {
      whatsappSame.addEventListener('change', () => {
        setWhatsAppSameState(form);
      });
    }

    setWhatsAppSameState(form);
    syncAllPhoneNumbers(form);
  }

  function restoreSubmitButton(form) {
    if (!form) return;

    const submitButton = form.querySelector(SELECTORS.submitButton);

    if (submitButton) {
      submitButton.disabled = false;
      submitButton.removeAttribute('aria-busy');
    }

    form.classList.remove(CLASSNAMES.submitting);
    delete form.dataset.absSubmitting;
  }

  function resetFormState(modal) {
    if (!modal) return;

    const form = modal.querySelector(SELECTORS.form);
    const successState = modal.querySelector(SELECTORS.successState);
    const errorState = modal.querySelector(SELECTORS.errorState);

    if (form) {
      form.hidden = false;
      form.classList.remove(
        CLASSNAMES.submitting,
        CLASSNAMES.success,
        CLASSNAMES.error
      );

      restoreSubmitButton(form);
    }

    if (successState) {
      successState.hidden = true;
    }

    if (errorState) {
      errorState.hidden = true;
    }
  }

  function showFormError(form, message) {
    if (!form) return;

    const errorState = form.querySelector(SELECTORS.errorState);

    form.classList.remove(CLASSNAMES.submitting, CLASSNAMES.success);
    form.classList.add(CLASSNAMES.error);

    restoreSubmitButton(form);

    if (errorState) {
      errorState.textContent =
        message ||
        'We could not submit your enquiry. Please check your connection and try again.';
      errorState.hidden = false;

      errorState.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });
    }
  }

  function showFormSuccess(form, projectName) {
    if (!form) return;

    const modal = form.closest(SELECTORS.modal);
    if (!modal) return;

    const successState = modal.querySelector(SELECTORS.successState);
    const errorState = form.querySelector(SELECTORS.errorState);

    form.classList.remove(CLASSNAMES.submitting, CLASSNAMES.error);
    form.classList.add(CLASSNAMES.success);

    if (errorState) {
      errorState.hidden = true;
    }

    restoreSubmitButton(form);

    form.reset();
    setProjectName(modal, projectName);

    const requestIdInput = form.querySelector(SELECTORS.requestIdInput);
    if (requestIdInput) {
      requestIdInput.value = '';
    }

    form.hidden = true;

    if (successState) {
      successState.hidden = false;

      const focusTarget =
        successState.querySelector(SELECTORS.closeButton) ||
        successState;

      if (
        focusTarget === successState &&
        !focusTarget.hasAttribute('tabindex')
      ) {
        focusTarget.setAttribute('tabindex', '-1');
      }

      window.setTimeout(() => {
        if (typeof focusTarget.focus === 'function') {
          focusTarget.focus({ preventScroll: true });
        }
      }, 80);
    }
  }

  function openDescriptionModal(modal, trigger) {
    if (!modal || !trigger) return;

    const title = modal.querySelector(SELECTORS.descriptionTitle);
    const location = modal.querySelector(SELECTORS.descriptionLocation);
    const body = modal.querySelector(SELECTORS.descriptionBody);

    const projectName =
      trigger.getAttribute('data-project-name') || 'Project information';

    const projectLocation =
      trigger.getAttribute('data-project-location') || '';

    const projectDescription =
      trigger.getAttribute('data-project-description') || '';

    if (title) {
      title.textContent = projectName;
    }

    if (location) {
      location.textContent = projectLocation;
      location.hidden = !projectLocation;
    }

    if (body) {
      body.textContent = projectDescription;
    }

    state.lastDescriptionFocusedElement = document.activeElement;
    state.activeDescriptionModal = modal;

    modal.hidden = false;

    requestAnimationFrame(() => {
      modal.classList.add(CLASSNAMES.modalOpen);
      document.body.classList.add(CLASSNAMES.bodyLocked);

      const panel = modal.querySelector(SELECTORS.descriptionPanel);
      const focusableElements = getFocusableElements(panel || modal);

      if (focusableElements.length) {
        focusableElements[0].focus({ preventScroll: true });
      } else if (panel) {
        panel.setAttribute('tabindex', '-1');
        panel.focus({ preventScroll: true });
      }
    });
  }

  function closeDescriptionModal(modal, restoreFocus = true) {
    if (!modal) return;

    modal.classList.remove(CLASSNAMES.modalOpen);

    window.setTimeout(() => {
      modal.hidden = true;

      if (state.activeDescriptionModal === modal) {
        state.activeDescriptionModal = null;
      }

      if (!state.activeModal) {
        document.body.classList.remove(CLASSNAMES.bodyLocked);
      }

      if (
        restoreFocus &&
        state.lastDescriptionFocusedElement &&
        typeof state.lastDescriptionFocusedElement.focus === 'function'
      ) {
        state.lastDescriptionFocusedElement.focus({ preventScroll: true });
      }

      state.lastDescriptionFocusedElement = null;
    }, 260);
  }

  function openModal(modal, trigger) {
    if (!modal || !trigger) return;

    const projectName =
      trigger.getAttribute('data-project-name') ||
      trigger.closest(SELECTORS.card)?.getAttribute('data-project-name') ||
      '';

    state.lastFocusedElement = document.activeElement;
    state.activeModal = modal;

    resetFormState(modal);
    setProjectName(modal, projectName);

    const form = modal.querySelector(SELECTORS.form);

    if (form) {
      setPageUrl(form);
    }

    modal.hidden = false;

    requestAnimationFrame(() => {
      modal.classList.add(CLASSNAMES.modalOpen);
      document.body.classList.add(CLASSNAMES.bodyLocked);

      const panel = modal.querySelector(SELECTORS.modalPanel);
      const focusableElements = getFocusableElements(panel || modal);

      if (focusableElements.length) {
        focusableElements[0].focus({ preventScroll: true });
      } else if (panel) {
        panel.setAttribute('tabindex', '-1');
        panel.focus({ preventScroll: true });
      }
    });
  }

  function closeModal(modal, restoreFocus = true) {
    if (!modal) return;

    modal.classList.remove(CLASSNAMES.modalOpen);
    document.body.classList.remove(CLASSNAMES.bodyLocked);

    const finishClose = () => {
      modal.hidden = true;

      if (state.activeModal === modal) {
        state.activeModal = null;
      }

      if (
        restoreFocus &&
        state.lastFocusedElement &&
        typeof state.lastFocusedElement.focus === 'function'
      ) {
        state.lastFocusedElement.focus({ preventScroll: true });
      }

      state.lastFocusedElement = null;
    };

    window.setTimeout(finishClose, 260);
  }

  function closeCountryPickersFromOutsideClick(event) {
    document.querySelectorAll(`${SELECTORS.countryPicker}.is-open`).forEach(
      (picker) => {
        if (!picker.contains(event.target)) {
          closeCountryPicker(picker);
        }
      }
    );
  }

  function handleModalClick(event) {
    closeCountryPickersFromOutsideClick(event);

    const descriptionOpenButton = event.target.closest(SELECTORS.descriptionOpen);

    if (descriptionOpenButton) {
      const section = descriptionOpenButton.closest(SELECTORS.section);
      const descriptionModal = section?.querySelector(SELECTORS.descriptionModal);

      if (descriptionModal) {
        event.preventDefault();
        openDescriptionModal(descriptionModal, descriptionOpenButton);
      }

      return;
    }

    const descriptionCloseButton = event.target.closest(SELECTORS.descriptionClose);

    if (descriptionCloseButton) {
      const descriptionModal = descriptionCloseButton.closest(
        SELECTORS.descriptionModal
      );

      if (descriptionModal) {
        event.preventDefault();
        closeDescriptionModal(descriptionModal);
      }

      return;
    }

    const descriptionModal = event.target.closest(SELECTORS.descriptionModal);

    if (descriptionModal && event.target === descriptionModal) {
      closeDescriptionModal(descriptionModal);
      return;
    }

    const openButton = event.target.closest(SELECTORS.openButton);

    if (openButton) {
      const section = openButton.closest(SELECTORS.section);
      if (!section) return;

      const modal = section.querySelector(SELECTORS.modal);

      if (modal) {
        event.preventDefault();
        openModal(modal, openButton);
      }

      return;
    }

    const closeButton = event.target.closest(SELECTORS.closeButton);

    if (closeButton) {
      const modal = closeButton.closest(SELECTORS.modal);

      if (modal) {
        event.preventDefault();
        closeModal(modal);
      }

      return;
    }

    const modal = event.target.closest(SELECTORS.modal);

    if (modal && event.target === modal) {
      closeModal(modal);
    }
  }

  function handleKeydown(event) {
    const descriptionModal = state.activeDescriptionModal;

    if (descriptionModal) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDescriptionModal(descriptionModal);
        return;
      }

      if (event.key === 'Tab') {
        const panel =
          descriptionModal.querySelector(SELECTORS.descriptionPanel) ||
          descriptionModal;

        const focusableElements = getFocusableElements(panel);

        if (!focusableElements.length) {
          event.preventDefault();
          return;
        }

        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault();
          lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault();
          firstElement.focus();
        }
      }

      return;
    }

    const modal = state.activeModal;

    if (!modal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal(modal);
      return;
    }

    if (event.key !== 'Tab') return;

    const panel = modal.querySelector(SELECTORS.modalPanel) || modal;
    const focusableElements = getFocusableElements(panel);

    if (!focusableElements.length) {
      event.preventDefault();
      return;
    }

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }

  function initRevealAnimations(scope = document) {
    const sections = scope.matches?.(SELECTORS.section)
      ? [scope]
      : Array.from(scope.querySelectorAll(SELECTORS.section));

    sections.forEach((section) => {
      if (section.dataset.absRevealInitialized === 'true') return;

      section.dataset.absRevealInitialized = 'true';

      const cards = Array.from(section.querySelectorAll(SELECTORS.card));

      if (!cards.length) return;

      cards.forEach((card, index) => {
        card.classList.add(CLASSNAMES.revealReady);
        card.style.setProperty(
          '--abs-reveal-delay',
          `${Math.min(index * 70, 420)}ms`
        );
      });

      if (
        !('IntersectionObserver' in window) ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        cards.forEach((card) => card.classList.add(CLASSNAMES.revealed));
        return;
      }

      const observer = new IntersectionObserver(
        (entries, currentObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            entry.target.classList.add(CLASSNAMES.revealed);
            currentObserver.unobserve(entry.target);
          });
        },
        {
          threshold: 0.14,
          rootMargin: '0px 0px -6% 0px'
        }
      );

      cards.forEach((card) => observer.observe(card));
    });
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    const controller =
      typeof AbortController !== 'undefined'
        ? new AbortController()
        : null;

    let timeoutId = null;

    if (controller) {
      options.signal = controller.signal;

      timeoutId = window.setTimeout(() => {
        controller.abort();
      }, timeoutMs);
    }

    return fetch(url, options).finally(() => {
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    });
  }

  async function handleFormSubmit(event) {
    event.preventDefault();

    const form = event.currentTarget;

    if (form.dataset.absSubmitting === 'true') {
      return;
    }

    const endpoint = (form.dataset.absEndpoint || form.action || '').trim();

    if (!endpoint || !endpoint.includes('/exec')) {
      showFormError(
        form,
        'The enquiry form is not connected yet. Please contact ABS Developers.'
      );
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const errorState = form.querySelector(SELECTORS.errorState);
    const submitButton = form.querySelector(SELECTORS.submitButton);
    const requestIdInput = form.querySelector(SELECTORS.requestIdInput);
    const projectName =
      form.querySelector(SELECTORS.projectInput)?.value || '';

    if (errorState) {
      errorState.hidden = true;
    }

    setPageUrl(form);
    syncAllPhoneNumbers(form);

    const requestId = createRequestId();

    if (requestIdInput) {
      requestIdInput.value = requestId;
    }

    form.dataset.absSubmitting = 'true';
    form.classList.remove(CLASSNAMES.error, CLASSNAMES.success);
    form.classList.add(CLASSNAMES.submitting);

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.setAttribute('aria-busy', 'true');
    }

    const formData = new FormData(form);

    try {
      await fetchWithTimeout(
        endpoint,
        {
          method: 'POST',
          mode: 'no-cors',
          cache: 'no-store',
          credentials: 'omit',
          redirect: 'follow',
          body: formData
        },
        SUBMISSION_TIMEOUT_MS
      );

      /*
        Google Apps Script returns an opaque response cross-origin.
        A resolved fetch means the request successfully reached the endpoint.
        The Apps Script backend validates and stores the row.
      */
      showFormSuccess(form, projectName);
    } catch (error) {
      console.error('[ABS Projects] Lead submission failed:', error);

      showFormError(
        form,
        'We could not send your enquiry. Please check your internet connection and try again.'
      );
    }
  }

  function initForms(scope = document) {
    const forms = scope.matches?.(SELECTORS.form)
      ? [scope]
      : Array.from(scope.querySelectorAll(SELECTORS.form));

    forms.forEach((form) => {
      if (form.dataset.absFormInitialized === 'true') return;

      form.dataset.absFormInitialized = 'true';
      setPageUrl(form);
      initPhoneFields(form);
      syncAllPhoneNumbers(form);
      form.addEventListener('submit', handleFormSubmit);
    });
  }

  function init(scope = document) {
    document.documentElement.classList.add(CLASSNAMES.jsReady);
    initRevealAnimations(scope);
    initForms(scope);
  }

  document.addEventListener('click', handleModalClick);
  document.addEventListener('keydown', handleKeydown);

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => init(document),
      { once: true }
    );
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (
      state.activeModal &&
      event.target.contains(state.activeModal)
    ) {
      document.body.classList.remove(CLASSNAMES.bodyLocked);
      state.activeModal = null;
      state.lastFocusedElement = null;
    }

    if (
      state.activeDescriptionModal &&
      event.target.contains(state.activeDescriptionModal)
    ) {
      document.body.classList.remove(CLASSNAMES.bodyLocked);
      state.activeDescriptionModal = null;
      state.lastDescriptionFocusedElement = null;
    }
  });
})();